import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './hooks/useAuth';
import { BrandingProvider } from './contexts/BrandingContext';
import { captureFromUrl, captureTouch } from './services/attribution';
import { reportHeldPurchase } from './services/analytics';
import './index.css';

// Capture ad click IDs (gclid/fbclid/msclkid) + the WP-landing flow hint
// BEFORE React Router can navigate away. Click IDs need to be readable from
// the page that fires the conversion event so Bing UET / Meta Pixel can
// stamp `_uetmsclkid_` / `_fbc` cookies; the React app then mirrors them
// into sessionStorage so a HomeRoute redirect doesn't lose attribution.
captureFromUrl();
captureTouch(); // persistent first/last touch (90 days) — sent at signup
reportHeldPurchase(); // a preview buyer's sale, handed over by the checkout page they just left

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <BrandingProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrandingProvider>
    </BrowserRouter>
  </React.StrictMode>
);
